<template>
  <div class="box">
    <div class="main">
      <div class="information">
        当前就诊人：*成成
        <button>切换</button>
      </div>
      <div class="barcode">
        <img src="../../assets/barcode.png" />
      </div>
      <div class="qrcode">
        <img src="../../assets/qrcode.png" />
      </div>
      <div class="text">我的登记号：1231231231</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'patientCode',
  data() {
    return {}
  },
  created() {},
  mounted() {},
  methods: {}
}
</script>
<style scoped>
.main {
  width: 100vw;
  height: 100vh;
  background-color: rgb(242, 242, 242);
}
.information {
  color: #ffffff;
  background-color: rgb(8, 112, 253);
  padding: 7px 10px;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.information button {
  background-color: #ffffff;
  font-size: 18px;
  color: rgb(79, 188, 251);
  border: 1px solid rgb(8, 112, 253);
  border-radius: 20px;
}
.barcode {
  width: 100vw;
  height: 120px;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
}
.barcode img {
  width: 80%;
  height: 100px;
  margin: 10px 0px;
}
.qrcode {
  margin: 50px auto;
  width: 230px;
  height: 230px;
}
.qrcode img {
  width: 100%;
  height: 100%;
}
.text {
  text-align: center;
}
</style>
